var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parallax-scrolling"},[(_vm.step === 1)?_c('Opening',{on:{"completed":_vm.nextStep}}):(_vm.step === 2)?_c('QuestionOne'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }